














































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import store from "@/store";
//  utilities
import dateHelper from "Utilities/date-helper";
import durationHelper from "Utilities/duration-helper";
import moment from "moment";
//  types
import { IndicatorData } from "@/types/dataQuality/dataQualityTable";
import { Condition, Threshold } from "@/types/condition";
import { ILongTrend } from "@/types/longTrend";
//  modules
import { getModule } from "vuex-module-decorators";
import IncidentsModule from "@/store/clients/Incidents.module";
import LongTrendsModule from "@/store/clients/LongTrends.module";

const Incidents = getModule(IncidentsModule, store);
const LongTrends = getModule(LongTrendsModule, store);

@Component({})
export default class DataIndicator extends Vue {
  @Prop({ type: Object }) data!: IndicatorData;

  //  @Data
  isPerformanceDataLoaded = false;
  longTrends: ILongTrend[] = [];
  latestLongTrendPeriods: any = [];

  //  @Watch
  @Watch("data", { immediate: true, deep: true })
  async onDataChange(newData: IndicatorData): Promise<void> {
    if (this.data.type === "indicator:performance") {
      const vesselId = Number(this.data.vesselId);
      if (!vesselId) return;
      try {
        this.longTrends = (await LongTrends.fetchVesselLongTrends(vesselId)) as ILongTrend[];
      } catch (error) {
        console.error("Error fetching long trends:", error);
      } finally {
        this.isPerformanceDataLoaded = true;
      }
    }
  }

  //  @Getters
  get isNotAvailable(): boolean {
    return this.data.status === -1;
  }

  get statusColor() {
    if (!this.data) return;
    if (this.data.status === 0) return "success100";
    else if (Number(this.data.status) > 0 && Number(this.data.status) <= 10) return "warning100";
    else if (Number(this.data.status) > 10) return "error100";
    else return "darkGrey100";
  }

  get valueClasses() {
    if (!this.data) return;
    if (this.data.status === 0) return "no-outliers";
    else if (Number(this.data.status) > 0 && Number(this.data.status) <= 10) return "minor";
    else if (Number(this.data.status) > 10) return "major";
    else return "not-available";
  }

  get hasWarnings(): boolean {
    if (!this.data.warningList) return false;
    return this.data.warningList.length > 0;
  }

  get hasCriticals(): boolean {
    if (!this.data.criticalList) return false;
    return this.data.criticalList.length > 0;
  }

  get warningsAmount(): number {
    if (!this.data.warningList) return 0;
    return this.data.warningList.length;
  }

  get criticalsAmount(): number {
    if (!this.data.criticalList) return 0;
    return this.data.criticalList.length;
  }

  get conditions(): Condition[] {
    return Incidents.conditions;
  }

  get longTrendPeriods(): any {
    return this.latestLongTrendPeriods;
  }

  //  @Methods
  trendStatusIcon(status: string): string {
    if (status === "Ok") return "$StatusOk";
    else if (status === "Observe") return "$StatusObserve";
    else if (status === "NotOk") return "$StatusNotOk";
    else if (status === "BenchMarking") return "$StatusBenchmarking";
    else return "";
  }

  getTrendValueDisplay(trend: ILongTrend): string {
    if (trend.performanceStatus === "BenchMarking") {
      return "Benchmarking";
    }
    if (trend.trendValueAtStatus !== undefined && trend.trendValueAtStatus !== null) {
      return `${trend.trendValueAtStatus.toFixed(1)}%`;
    }
    return "N/A";
  }

  navigateToLink(): void {
    if (!this.data.link) throw new Error("Link is undefined");
    this.$router.push(this.data.link);
  }

  redirectToDiagnostics(): void {
    if (!this.data.vesselId || !this.data.vesselName) throw new Error("Vessel ID/Name is undefined");
    const vesselIdStr = String(this.data.vesselId);
    const vesselNameStr = String(this.data.vesselName);
    this.$router.push({
      path: `/Vessel/${vesselIdStr}/${encodeURIComponent(vesselNameStr)}`,
      name: "Diagnostics",
      params: { vesselId: vesselIdStr, vesselName: encodeURIComponent(vesselNameStr) },
    });
  }

  redirect(): void {
    this.$router.push({ path: "/Notifications", query: { search: this.data.vesselName } });
  }

  getFormatedDateTimeString(timestamp: string): string {
    return dateHelper.getFormatedDateTimeString(timestamp);
  }

  formattedDate(timestamp: string): string {
    return moment(timestamp).format("llll");
  }

  duration(timestamp: string): string {
    return dateHelper.getHumanizeDuration(timestamp, moment().valueOf());
  }

  durationValueFromSeconds(seconds: number): string {
    return durationHelper.getDurationValueFromSeconds(seconds);
  }

  durationUnitFromSeconds(seconds: number): string {
    return durationHelper.getDurationUnitFromSeconds(seconds);
  }

  thresholdByConditionId(severity: string, conditionId: number): Threshold {
    const condition = this.conditions.find(c => c.id === conditionId);
    if (!condition) return {} as Threshold;
    return condition.thresholds.find(threshold => threshold.severity === severity) || ({} as Threshold);
  }

// @Hooks
}
